import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { StarRating } from '../ui/StarRating';
const testimonials = [{
  text: 'Compré el manual un domingo por la noche. El lunes entré al pabellón con la sesión exacta planificada. Los chavales lo notaron desde el primer ejercicio. Espectacular.',
  name: 'Carlos M.',
  role: 'Entrenador Infantil · Club Baloncesto Valladolid'
}, {
  text: 'Pensé que era otro PDF teórico más. Pero esto es diferente. Las consignas clave de cada ejercicio son oro puro. Nadie te enseña eso en los cursillos de entrenadores.',
  name: 'Raquel F.',
  role: 'Entrenadora Mini · Madrid'
}, {
  text: 'Soy profesora de Educación Física y también entreno los fines de semana. El tiempo es lo que más me falta. Este manual me ha devuelto los domingos. Ya no planifico. Solo ejecuto.',
  name: 'Laura G.',
  role: 'Profesora y Entrenadora · Zaragoza'
}, {
  text: 'Al principio me pareció demasiado barato para ser bueno. Me equivoqué. La calidad del contenido está muy por encima del precio. Lo recomendaría a cualquier entrenador de base sin dudarlo.',
  name: 'Iñaki A.',
  role: 'Director Técnico · Club Basket Bilbao'
}, {
  text: 'Llevo el PDF en el móvil y lo consulto en pista sin que nadie lo note. Es como tener un segundo entrenador al lado que te recuerda qué tienes que decir en cada momento.',
  name: 'Pablo C.',
  role: 'Entrenador Infantil · Murcia'
}, {
  text: 'Llevaba tres temporadas en Cadete sin saber si lo estaba haciendo bien. Con este manual por primera vez siento que hay un hilo conductor real en mis entrenamientos.',
  name: 'Sergio B.',
  role: 'Entrenador Cadete · Valencia'
}, {
  text: 'El Cronograma Maestro del Pack Premium es lo que hace que todo encaje. Antes tenía los tomos pero no sabía cuándo usar cada uno. Ahora sigo el mapa y el equipo progresa semana a semana.',
  name: 'Tomás V.',
  role: 'Entrenador Infantil · Alicante'
}, {
  text: 'La Versión Pocket me parece un lujo. La tengo en el móvil y cuando necesito recordar la consigna clave de un ejercicio la encuentro en 5 segundos sin interrumpir el entrenamiento.',
  name: 'Elena M.',
  role: 'Monitora Premini y Mini · Salamanca'
}, {
  text: 'Los bonos de calentamientos son los que más uso. Por fin mis sesiones empiezan con energía desde el primer minuto. Los jugadores llegan al bloque principal ya activados y concentrados.',
  name: 'Marta R.',
  role: 'Directora Técnica · Escuela de Basket Sevilla'
}];
export function Testimonials() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-273" data-mp="3r3e630x4slg5">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-274" data-mp="3w1fn7gazyaoz">
        <SectionTag icon="⭐" data-id="element-275" data-mp="3w1z9183rpj8a">Testimonios reales</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-276" data-mp="3i1emq1yn95a1">
          Entrenadores de toda España ya lo usan.
        </h2>
        <div className="mt-4 flex items-center justify-center gap-2" data-id="element-277" data-mp="33ey380vtadj2">
          <StarRating size={18} data-id="element-278" data-mp="33f7t7oguwkor" />
          <span className="text-sm text-muted" data-id="element-279" data-mp="2yg4ns2wyscg9">+500 reseñas verificadas</span>
        </div>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-280" data-mp="3cfe5j70tjemc">
        {testimonials.map((t, i) => <m.div key={t.name} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="flex flex-col rounded-2xl border border-white/10 bg-bg-secondary p-6" data-id="element-281" data-mp="38d9emg1r8w3e" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-282" data-mp="3r4k18l0g6mph">
              <StarRating size={14} data-id="element-283" data-mp="3r525o4x9k78h" />
              <span aria-hidden="true" data-id="element-284" data-mp="8yxb3apjb66t">🇪🇸</span>
            </div>
            <p className="mt-3 flex-1 text-sm leading-relaxed text-white/90" data-id="element-285" data-mp="8z6yqrn3x19c">"{t.text}"</p>
            <div className="mt-4 border-t border-white/10 pt-3" data-id="element-286" data-mp="41fac7lo7x9w">
              <p className="text-sm font-semibold text-white" data-id="element-287" data-mp="1yguh84gntqui">{t.name}</p>
              <p className="text-xs text-muted" data-id="element-288" data-mp="23f5nk57qxj7z">{t.role}</p>
            </div>
          </m.div>)}
      </div>

      <p className="mt-6 text-center text-sm text-muted sm:text-base" data-id="element-289" data-mp="285ce4altjdsv">
        Más de <span className="font-semibold text-orange" data-id="element-290" data-mp="2c7g03t6460se">8.000 entrenadores</span> en España ya entrenan
        con EL MANUAL DEL ENTRENADOR DE BALONCESTO.
      </p>
    </section>;
}